import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import React from 'react'
import PatternBonusHeader from './patternBonusHeader'
import { GatsbyImage } from 'gatsby-plugin-image'
interface Props {
  image?: IGatsbyImageDataObject
}
function PatternBonus4(props: Props) {
  const { image } = props
  return (
    <div className='py-12 et-grid-basic lg:py-20 bg-cream-200'>

      {/* header */}
      <PatternBonusHeader
        subTitle='Bonus Module 4'
        title='Convert your Procreate Patterns into Rasterized Illustrator Swatches + Photoshop .PAT Files'
        containerClassNames='xl:!col-start-4 xl:col-span-8'
      />

      {/* image */}
      {image && <div className='relative col-span-2 col-start-2 row-start-2 px-10 pt-4 pb-8 md:py-0 md:col-start-4 md:col-span-8 lg:col-start-2 lg:col-span-6'>
        <div className='shadow-shadow3'>
          <GatsbyImage image={image.gatsbyImageData} alt='Procreate Pattern: Bonus 1' />
        </div>
      </div>}

      <div className='col-span-2 col-start-2 md:col-start-4 md:col-span-8 lg:col-start-8 lg:col-span-6'>
        <p className='mb-4 text-lg lg:text-xl'>There may come a time that you'd like to use your Procreate patterns as an automated repeat in Adobe Illustrator or Photoshop and I want to make sure you to know how to do that..so, cue another bonus! 🤓</p>

        <p className='mb-4 text-lg lg:text-xl'>We'll start by exporting our Procreate pattern square and importing it into Adobe Illustrator. From there, we'll create a perfectly repeating rasterized Illustrator pattern swatch - <span className='font-bold'>please note that we will not be vectorizing our art</span>; we'll simply be making it available to use as a repeatable pattern within Illustrator's environment.</p>

        <p className='mb-4 text-lg lg:text-xl'>I'll show you how to export that Illustrator swatch and then import it back into Illustrator, so you can sell it or use it within other Illustrator files in the future.</p>

        <p className='mb-4 text-lg lg:text-xl'>Next, we'll hop into Photoshop! I'll share how to convert each pattern type (full drop, half drop + half brick) into a Photoshop .PAT file, then how to export and import that file, so it's also ready to sell or use for other projects.</p>

      </div>


    </div>
  )
}

export default PatternBonus4